import Config from '@config';
import { initializeMeteringDeviceTypeApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringDeviceTypes = initializeMeteringDeviceTypeApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringDeviceTypesApi,
  useGetMeteringDeviceTypeByIdQuery,
  useGetMeteringDeviceTypeInfiniteQuery,
} = meteringDeviceTypes;
